import { useEffect } from "react";
import { useParams } from "react-router-dom";

import useFetch from "shared/model/useFetch";
import useAlertModalAtom from "shared/model/useAlertModalAtom";

const usePostReEntryIncrease = () => {
  const { idx } = useParams();

  const [fetchResult, fetchRequest] = useFetch();

  const [, setAlert] = useAlertModalAtom();

  const request = (reEntryChip) => {
    fetchRequest("POST", `/admin/timer/reentry/increase`, {
      event_idx: idx,
      re_entry_chip: reEntryChip,
    });
  };

  useEffect(() => {
    switch (fetchResult?.statusCode) {
      case 400:
        if (fetchResult?.data?.error_code === 1)
          setAlert("아직 대회가 시작되지 않았습니다.");
        break;
      case 404:
        if (fetchResult?.data?.error_code === 1)
          setAlert("대회 데이터가 존재하지 않습니다.");
        break;
    }
  }, [fetchResult]);

  return [request];
};

export default usePostReEntryIncrease;
